export default __webpack_public_path__ + "static/media/skill_c.c0da8156.png";